import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { SettingFilled, HomeOutlined } from '@ant-design/icons';
import { Layout, Row, Col, Button, Space, Modal } from "antd";
export default function FetchCSVData() {
    const [csvData, setCsvData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    useEffect(() => {
        fetchCSVData();
    }, []);

    useEffect(() => {
        applyFilter();
    }, [searchTerm, csvData]);

    useEffect(() => {
        if (sortConfig.key) {
            sortData(sortConfig.key, sortConfig.direction);
        }
    }, [sortConfig]);

    const fetchCSVData = () => {
        const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSX1Caoo3ikmlja3tPwugCG5Tj6A8uwfZ0nP2tjWwkQEhkLECauJ-y_VmCLKxnBGw/pub?gid=1817765768&single=true&output=csv';

        setLoading(true);
        axios.get(csvUrl)
            .then((response) => {
                const parsedCsvData = parseCSV(response.data);
                setCsvData(parsedCsvData);
                setFilteredData(parsedCsvData); // Initialize with full data
            })
            .catch((error) => {
                console.error('Error fetching CSV data:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const parseCSV = (csvText) => {
        const rows = csvText.trim().split(/\r?\n/);
        const headers = rows[0].split(',');
        const data = [];

        for (let i = 1; i < rows.length; i++) {
            const rowData = rows[i].split(',');
            if (rowData.length !== headers.length) continue;

            const rowObject = {};
            for (let j = 0; j < headers.length; j++) {
                rowObject[headers[j]] = rowData[j];
            }
            data.push(rowObject);
        }
        return data;
    };

    const applyFilter = () => {
        const lowercasedFilter = searchTerm.toLowerCase();
        const filtered = csvData.filter((row) =>
            Object.values(row).some(
                (value) => value && value.toLowerCase().includes(lowercasedFilter)
            )
        );
        setFilteredData(filtered);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortData = (key, direction) => {
        const sorted = [...filteredData].sort((a, b) => {
            const valA = a[key] ? a[key].toString().toLowerCase() : '';
            const valB = b[key] ? b[key].toString().toLowerCase() : '';

            if (!isNaN(valA) && !isNaN(valB)) {
                return direction === 'asc' ? valA - valB : valB - valA;
            }

            return direction === 'asc'
                ? valA.localeCompare(valB)
                : valB.localeCompare(valA);
        });

        setFilteredData(sorted);
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return '⇅';
        return sortConfig.direction === 'asc' ? '⬆' : '⬇';
    };

    return (
        <div>
            <Row>
                <Col span={20}><h3>Contrast - Task Management</h3></Col>
                <Col span={4}>
                    <div style={{ marginTop: '20px' }}>
                    <Link aria-current="page" to="/dashboard">
                        <Button type="danger" icon={<HomeOutlined />}>
                            Dashboard
                        </Button>
                    </Link>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                <div>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            marginBottom: '15px',
                            padding: '8px',
                            width: '300px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            border: '1px solid #ccc'
                        }}
                    />

                    {loading ? (
                        <p>Loading Google Sheet data...</p>
                    ) : (
                        <table className="product_table" border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ backgroundColor: '#f0f0f0' }}>
                                <tr>
                                    {filteredData.length > 0 &&
                                        Object.keys(filteredData[0]).map((header, index) => (
                                            <th key={index} onClick={() => handleSort(header)} style={{ cursor: 'pointer', textAlign: 'left',  padding: '10px' }}>
                                                {header} {getSortIcon(header)}
                                            </th>
                                        ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {Object.values(row).map((value, colIndex) => (
                                            <td style={{ textAlign: 'left', padding: '8px' }} key={colIndex}>{value}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}  
                </div>
                </Col>

            </Row>
            


            
        </div>


    );
}
